import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DOCOnlineService } from "../../../services/DOCOnlineService";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ProgressBar from "../../../components/DocProgressBar/ProgressBar";
import DOCOnlinePersonalInformation from "./DOCOnlinePersonalInformation";
import DOCOnlineEducationAndLanguage from "./DOCOnlineEducationAndLanguage/DOCOnlineEducationAndLanguage";
import DOCOnlineWorkExperience from "./DOCOnlineWorkExperience/DOCOnlineWorkExperience";
import DOCOnlineSpinner from "../../../containers/FullPageSpinner/FullPageSpinner";
import DOCOnlineTechSkillsList from "./DOCOnlineTechSkills/DOCOnlineTechSkillsList";
import ModalSaveAsDocOnline from "./ModalSaveAsDocOnline";
import ModalDownloadDocOnline from "./ModalDownloadDocOnline";
import DownloadStatusSpinner from "../../../components/DownloadStatusSpinner/DownloadStatusSpinner";
import moment from "moment";
import "../../../pages/DOCOnline/DOCOnline.scss";
import { translateAndSortAscendant } from "../../../common/helper";
import ModalWebDocOnline from "./ModalWebDocOnline";

const DOCOnlineBody = ({
  docOnline,
  isLoading,
  setDocOnline,
  interviewId,
  docOnlineController
}) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(2);
  const [showModalSaveAsDocOnline, setShowModalSaveAsDocOnline] = useState(false);
  const [haswebView, setHaswebview] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [languageLevels, setLanguageLevels] = useState([]);
  const [errors, setErrors] = useState([{}]);
  const [errorTitleRequired, setTitleRequired] = useState({});
  const [jobRoles, setJobRoles] = useState([]);
  const [zones, setZones] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [yearsExperience, setYearexperience] = useState([]);
  const [skillLevels, setSkillLevels] = useState([]);
  const [techSkills, setTechSkills] = useState([]);
  const [techSkillsHasLoaded, setTechSkillsHasLoaded] = useState(false);
  const [comboBoxList, setComboboxList] = useState([]);
  const [showWebModal, setShowWebModal] = useState(false);

  function generateUrl(langId, companyId) {
    docOnlineController.docOnlineService
      .generateUrl(langId, companyId, docOnline.id)
      .then((data) => {
        navigator.clipboard.writeText(data.url);

        setTimeout(() => window.open(data.url), 2000);
        setShowWebModal(false);
      });
  }

  useEffect(() => {
    if (techSkills.length === 0) {
      docOnlineController.commonService.getTechSkills().then((data) => {
        setTechSkills(translateAndSortAscendant(data, "description"));
        setComboboxList(
          data.map((x) => {
            return { key: x.description, description: x.description };
          })
        );
        setTechSkillsHasLoaded(true);
        setComboboxList(translateAndSortAscendant(data, "description"));
      });
    }
  }, [docOnlineController]);

  useEffect(() => {
    if (docOnline.companyId !== 0 && zones.length === 0)
      docOnlineController.docOnlineService
        .getlAllZonesByCompany(docOnline.companyId)
        .then((result) => setZones(result));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docOnline.companyId]);

  useEffect(() => {
    docOnlineController.docOnlineService.hasWebView().then((data) => setHaswebview(data.webView));

    if (jobRoles && jobRoles.length === 0)
      docOnlineController.commonService
        .getAllJobRoles()
        .then((result) =>
          setJobRoles(translateAndSortAscendant(result, "description"))
        );

    if (maritalStatus && maritalStatus.length === 0) GetAllMaritalStatus();
    if (languages && languages.length === 0)
      docOnlineController.docOnlineService
        .getlAllLanguages()
        .then((result) => setLanguages(result));
    if (languageLevels && languageLevels.length === 0)
      docOnlineController.docOnlineService
        .getAllLanguageLevels()
        .then((result) => setLanguageLevels(result));
    if (yearsExperience.length === 0) {
      docOnlineController.docOnlineService
        .getAllYearsExperience()
        .then((data) => setYearexperience(data));
    }
    if (skillLevels.length === 0) {
      docOnlineController.docOnlineService
        .GetAllSkillLevels()
        .then((data) => setSkillLevels(data));
    }
  }, []);

  const GetAllMaritalStatus = () => {
    docOnlineController.commonService
      .getAllMaritalStatus()
      .then((status) => setMaritalStatus(status));
  };
  const [showModalDownloadDocOnline, setShowModalDownloadDocOnline] = useState(
    false
  );
  const [docOnlineDownloadStatus, setDocOnlineDownloadStatus] = useState({
    statusName: "done",
    errorCaught: false
  });

  const [autoCompleteCourseData, setAutoCompleteCourseData] = useState([]);
  const [autoCompleteSchoolData, setAutoCompleteSchoolData] = useState([]);

  useEffect(() => {
    docOnlineController.commonService
      .getAllCourses()
      .then((courses) => {
        if (courses !== undefined) {
          setAutoCompleteCourseData(
            courses.map((course) => {
              return {
                id: course.id,
                name: course.description
              };
            })
          );
        } else {
          setAutoCompleteCourseData([]);
        }
      })
      .catch((error) => {
        toast.error(
          t("There was an error while trying to fetch the courses list.")
        );
        console.error(error);
        setAutoCompleteCourseData([]);
      });

    docOnlineController.commonService
      .getAllSchools()
      .then((schools) => {
        if (schools !== undefined) {
          setAutoCompleteSchoolData(
            schools.map((school) => {
              return {
                id: school.id,
                name: school.description
              };
            })
          );
        } else {
          setAutoCompleteSchoolData([]);
        }
      })
      .catch((error) => {
        toast.error(
          t("There was an error while trying to fetch the courses list.")
        );
        console.error(error);
        setAutoCompleteSchoolData([]);
      });
  }, []);

  const yearsOfExperienceIsValid = (value) => {
    if (value) {
      let yearsOfExperience = parseInt(value);
      if (isNaN(yearsOfExperience) === false) {
        if (yearsOfExperience >= 0 && yearsOfExperience <= 50) {
          return true;
        }
      }
    }
    return false;
  };

  const resumeLenghtValid = (value) => {
    if (value) {
      let resumeLenght = parseInt(value.length);
      if (resumeLenght >= 30) {
        return true;
      }
    }
    return false;
  };

  const checkPersonalInfoErrors = () => {
    const {
      fullName,
      birthDate,
      jobRoleId,
      yearsOfExperience,
      mobilePhoneNumber,
      resume
    } = docOnline.personalInformation;
    const personalInfoErrors = {};

    if (resumeLenghtValid(resume) === false) {
      personalInfoErrors.resume = t("Minimum 30 characters required.");
    }

    if (!fullName) {
      personalInfoErrors.fullName = t("The Full Name is required.");
    }

    if (!birthDate) {
      personalInfoErrors.birthDate = t("The BirthDate is required.");
    }

    if(birthDate === "0001-01-01T00:00:00"){
      personalInfoErrors.birthDate = t("The BirthDate is not allowed.");
    }

    if (!jobRoleId) {
      personalInfoErrors.jobRoleId = t("The Job Role is required.");
    }

    if (!yearsOfExperience) {
      personalInfoErrors.yearsOfExperience = t(
        "The Years of Experience is required."
      );
    } else {
      if (yearsOfExperienceIsValid(yearsOfExperience) === false) {
        personalInfoErrors.yearsOfExperience = t(
          "The Years of Experience is required."
        );
      }
    }

    return personalInfoErrors;
  };

  const checkEducationErrors = () => {
    const educationErrors = { otherLanguages: [], educationAndTraining: [] };
    const { motherLanguage, otherLanguages } = docOnline;

    if (
      motherLanguage === null ||
      motherLanguage === "" ||
      motherLanguage === undefined
    ) {
      educationErrors.motherLanguage = t("The Native Language is required.");
    }

    otherLanguages.forEach((item, index) => {
      if (!item.languageId) {
        educationErrors.otherLanguages[index] = {
          ...educationErrors.otherLanguages[index],
          languageId: t("The Language is required ")
        };
      }

      if (!item.languageLevelId) {
        educationErrors.otherLanguages[index] = {
          ...educationErrors.otherLanguages[index],
          languageLevelId: t("The language level is requered")
        };
      }
    });

    if (
      !!educationErrors.motherLanguage ||
      educationErrors.otherLanguages.length > 0 ||
      educationErrors.educationAndTraining.length > 0
    ) {
      return educationErrors;
    } else {
      return {};
    }
  };

  const checkWorkExpErrors = () => {
    const workExpErrors = { workExperience: [] };
    const { workExperience } = docOnline;

    workExperience.forEach((item, index) => {
      if (
        item.occupationOrPositionHeld ||
        item.companyOrEmployName ||
        item.startDate ||
        item.endDate
      ) {
        if (!item.occupationOrPositionHeld) {
          workExpErrors.workExperience[index] = {
            occupationOrPositionHeld: t(
              "The Occupation or position held is required."
            )
          };
        }

        if (!item.companyOrEmployName) {
          workExpErrors.workExperience[index] = {
            ...workExpErrors.workExperience[index],
            companyOrEmployName: t("The Company/Employer name is required.")
          };
        }

        if (!item.startDate) {
          workExpErrors.workExperience[index] = {
            ...workExpErrors.workExperience[index],
            startDate: t("The Start Date is required.")
          };
        }

        if (!item.endDate) {
          if (!item.projectStillGoing) {
            workExpErrors.workExperience[index] = {
              ...workExpErrors.workExperience[index],
              endDate: t("The End Date is required")
            };
          }
        }

        if (item.startDate && item.endDate) {
          if (moment(item.endDate).isBefore(item.startDate)) {
            workExpErrors.workExperience[index] = {
              ...workExpErrors.workExperience[index],
              endDate: t("The end date is invalid.")
            };
          }
        }
      }
    });

    if (workExpErrors.workExperience.length === 0) {
      return {};
    } else {
      return workExpErrors;
    }
  };

  const checkTechSkillsErrors = () => {
    const techSkillErrors = { competences: [], otherCompetences: [] };
    const { competences, otherCompetences } = docOnline;

    if (competences && competences.length < 1) {
      if (otherCompetences && otherCompetences.length < 1) {
        techSkillErrors.DOCOnlineTechSkill = t(
          "At least one technical skill is required."
        );
      }
    }

    competences.forEach((item) => {
      if (!item.skillLevelId) {
        techSkillErrors.competences[item.skillId] = {
          ...techSkillErrors.competences[item.skillId],
          skillLevelId: t("Select the level of experience")
        };
      }
      if (!item.skillExperienceTimeId) {
        techSkillErrors.competences[item.skillId] = {
          ...techSkillErrors.competences[item.skillId],
          skillExperienceTimeId: t("Select the experience time")
        };
      }
    });
    
    if (otherCompetences && otherCompetences.length > 0) {
      techSkillErrors.otherCompetences = otherCompetences.reduce(
        (accumulator, item, index) => {
          const error = {};

          if (!item.skillLevelId) {
            error.skillLevelId = t("Select the level of experience");
          }

          if (!item.skillExperienceTimeId) {
            error.skillExperienceTimeId = t("Select the experience time");
          }

          if (Object.keys(error).length > 0) {
            accumulator[index] = error;
          }

          return accumulator;
        },
        []
      );
    }

    if (
      Object.keys(techSkillErrors.competences).length === 0 &&
      techSkillErrors.otherCompetences.length === 0 &&
      !techSkillErrors.DOCOnlineTechSkill
    ) {
      return {};
    } else {
      return techSkillErrors;
    }
  };

  const isRequiredFieldsFilled = () => {
    const personalInfoErrors = checkPersonalInfoErrors();
    const educationErrors = checkEducationErrors();
    const workExperienceErrors = checkWorkExpErrors();
    const techSkillErrors = checkTechSkillsErrors();

    const docOnlineErrors = {
      ...personalInfoErrors,
      ...educationErrors,
      ...workExperienceErrors,
      ...techSkillErrors
    };

    setErrors(docOnlineErrors);

    return Object.keys(docOnlineErrors).length === 0 ? true : false;
  };

  const ConfirmSaveAsDocOnline = () => {
    if (docOnline.title && docOnline.title !== "") {
      setShowModalSaveAsDocOnline(false);

      docOnlineController.saveAs(docOnline).then((data) => {
        if (data === undefined) {
          toast.success(t("DOC Online saved successfully"));
        } else {
          toast.error(t("An unexpected error occured"));
        }
      });
    } else {
      setTitleRequired({ title: "The title is required " });
    }
  };

  const save = () => {
    if (isRequiredFieldsFilled() === false) {
      toast.warning(`${t("Some mandatory fields were not filled.")}`);
      return;
    } else {
      // Filtering educationAndTraining object for completely empty fields before saving.
      let _docOnline = { ...docOnline };
      _docOnline.educationAndTraining = docOnline.educationAndTraining.filter(
        (educationInfo) =>
          Object.keys(educationInfo).length !== 0 &&
          ((educationInfo.course ?? educationInfo.course) ||
            (educationInfo.courseId ?? educationInfo.courseId) ||
            (educationInfo.courseName ?? educationInfo.courseName) ||
            (educationInfo.school ?? educationInfo.school) ||
            (educationInfo.schoolId ?? educationInfo.schoolId) ||
            (educationInfo.schoolName ?? educationInfo.schoolName) ||
            (educationInfo.endDate ?? educationInfo.endDate) ||
            (educationInfo.startDate ?? educationInfo.startDate))
      );

      docOnlineController.save(_docOnline).then((data) => {
        if (data?.error) {
          toast.error(t("An unexpected error occured"));
        } else if (interviewId) setDocOnline({ ...docOnline, id: data });
        toast.success(t("DOC Online saved successfully"));
      });
    }
  };

  const saveAs = () => {
    if (isRequiredFieldsFilled() === false) {
      toast.warning(`${t("Some mandatory fields were not filled.")}`);
      return;
    } else {
      setShowModalSaveAsDocOnline(true);
    }
  };
  function closeWebModal() {
    setShowWebModal(false);
  }

  if (!isLoading) {
    return (
      <>
        {currentStep <= 6 && (
          <ProgressBar
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            showWelcomeCircle={false}
            showUploadDocument={false}
            checkPersonalInfoErrors={checkPersonalInfoErrors}
            checkEducationErrors={checkEducationErrors}
            checkWorkExpErrors={checkWorkExpErrors}
            checkTechSkillsErrors={checkTechSkillsErrors}
          />
        )}
        <div>
          <div className="button-doconline-controls">
            <DownloadStatusSpinner
              downloadStatus={docOnlineDownloadStatus.statusName}
              errorCaught={docOnlineDownloadStatus.errorCaught}
              textPending={t("Downloading")}
              textDone={t("Done")}
            />
            {(docOnline.description !== "Submetido pelo candidato" &&  docOnline.description !== "Submmited by candidate") && (
              <button
                className="app-button btn-prime btn-md"
                type="button"
                onClick={save}
              >
                {t("Save")}
              </button>
            )}
            {!docOnline.id == 0 && (
              <>
                <button
                  className="app-button btn-prime btn-md"
                  type="button"
                  onClick={saveAs}
                >
                  {t("Save As")}
                </button>
                <button
                  className="app-button btn-prime btn-md"
                  type="button"
                  onClick={() => setShowModalDownloadDocOnline(true)}
                  disabled={
                    docOnlineDownloadStatus.statusName === "downloading"
                  }
                >
                  {t("Download")}
                </button>
                {haswebView && (
                  <>
                    <button
                      title={t("View&Copy")}
                      onClick={() => {
                        setShowWebModal(true);
                      }}
                      className="app-button btn-prime btn-md"
                    >
                      {t("Web")}
                    </button>
                  </>
                )}
              </>
            )}
          </div>

          <form className="doc-online-container">
            <section className="step">
              {currentStep === 2 && (
                <DOCOnlinePersonalInformation
                  docOnline={docOnline}
                  setDocOnline={setDocOnline}
                  errors={errors}
                  setErrors={setErrors}
                  jobRoles={jobRoles}
                  maritalStatus={maritalStatus}
                  zones={zones}
                />
              )}
              {currentStep === 3 && (
                <DOCOnlineEducationAndLanguage
                  docOnline={docOnline}
                  autoCompleteCourseData={autoCompleteCourseData}
                  autoCompleteSchoolData={autoCompleteSchoolData}
                  setDocOnline={setDocOnline}
                  languageLevels={languageLevels}
                  languages={languages}
                  errors={errors}
                />
              )}
              {currentStep === 4 && (
                <DOCOnlineWorkExperience
                  docOnline={docOnline}
                  setDocOnline={setDocOnline}
                  errors={errors}
                />
              )}
              {currentStep === 5 && (
                <DOCOnlineTechSkillsList
                  docOnline={docOnline}
                  setDocOnline={setDocOnline}
                  errors={errors}
                  comboBoxList={comboBoxList}
                  skillLevels={skillLevels}
                  yearsExperience={yearsExperience}
                  techSkills={techSkills}
                  techSkillsHasLoaded={techSkillsHasLoaded}
                  DOCOnlineService={DOCOnlineService}
                />
              )}

              <div className="text-end">
                {currentStep > 2 && (
                  <button
                    className="app-button btn-second btn-md"
                    type="button"
                    onClick={() => {
                      setCurrentStep(currentStep - 1);
                    }}
                  >
                    {t("Back")}
                  </button>
                )}
                {currentStep < 5 && (
                  <button
                    className="app-button btn-prime btn-md"
                    type="button"
                    onClick={() => {
                      setCurrentStep(currentStep + 1);
                    }}
                  >
                    {t("Next")}
                  </button>
                )}
              </div>
            </section>
          </form>
        </div>
        <ModalSaveAsDocOnline
          showModalSaveAsDocOnline={showModalSaveAsDocOnline}
          setShowModalSaveAsDocOnline={setShowModalSaveAsDocOnline}
          docOnline={docOnline}
          setDocOnline={setDocOnline}
          submitButtonActionFunction={ConfirmSaveAsDocOnline}
          error={errorTitleRequired}
          setError={setTitleRequired}
        />
        <ModalDownloadDocOnline
          showModalDownloadDocOnline={showModalDownloadDocOnline}
          setShowModalDownloadDocOnline={setShowModalDownloadDocOnline}
          docOnlineId={docOnline.id}
          candidateFullName={docOnline.personalInformation.fullName}
          downLoadDocOnline={docOnlineController.downloadDocOnline}
          docOnlineService={docOnlineController.docOnlineService}
        />
        <ModalWebDocOnline
          show={showWebModal}
          close={closeWebModal}
          submit={generateUrl}
          docOnlineService={docOnlineController.docOnlineService}
        />
      </>
    );
  } else {
    return <DOCOnlineSpinner text={t("Please wait while the page loads...")} />;
  }
};

export default DOCOnlineBody;
